import React from "react";
import "./columns.css";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import Task from "../Task/task";

export const Column = ({ tasks, onDelete, selectedTasks, onTaskSelection }) => {
  return (
    <div className="column">
      <SortableContext items={tasks} strategy={verticalListSortingStrategy}>
        {tasks.map((task) => (
          <Task
            id={task.id}
            title={task.title}
            color={task.color}
            key={task.id}
            onDelete={onDelete}
            isSelected={selectedTasks ? selectedTasks.has(task.id) : false}
            onSelectionChange={onTaskSelection}
          />
        ))}
      </SortableContext>
    </div>
  );
};
